import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { ReportStockListResponse, ReportStocksProductQuantityListResponse, StockQueryParams } from '@frontend/stock/types';

export class StockReportClient extends APIClient {
    public static readonly endpoint = '/stock-api/v1';

    public static async fetchStocksReport(queryParams?: ApiQueryParams<DefaultQueryParams | StockQueryParams>): Promise<ReportStockListResponse> {
        return await this.apiPaginated(`${this.endpoint}/stocks-report`, queryParams);
    }

    public static async fetchReportStocksProductQuantity(
        queryParams?: ApiQueryParams<DefaultQueryParams | StockQueryParams>
    ): Promise<ReportStocksProductQuantityListResponse> {
        return await this.apiPaginated(`${this.endpoint}/report-stocks-product-quantity`, queryParams);
    }
}
